const monthNamesDefault = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec'
];

export const formatDateNumbers = (str, delimeter = '/') => {
  if (!str) return ''
  const date = new Date(str)
  if (date.toString() === 'Invalid Date') return `${str}`.trim()
  const day = date.getDate()
  const month = date.getMonth() + 1
  const year = date.getFullYear()
  return `${day < 10 ? '0' : ''}${day}${delimeter}${month < 10 ? '0' : ''}${month}${delimeter}${year}`
}

export const formatDate = (str, monthNames = monthNamesDefault) => {
  if (!str) return '/'
  const date = new Date(str)
  if (date.toString() === 'Invalid Date') return str
  const day = date.getDate()
  const month = date.getMonth() + 1
  const year = date.getFullYear()
  // const hours = date.getHours();
  // const mins = date.getMinutes();
  // eslint-disable-next-line
  return `${day < 10 ? '0' : ''}${day} ${monthNames[month - 1]} ${year}`
}

export const formatTime = (str) => {
  if (!str) return '/'
  const date = new Date(str)
  if (date.toString() === 'Invalid Date') return str
  const hours = date.getHours()
  const mins = date.getMinutes()
  // eslint-disable-next-line
  return `${hours < 10 ? '0' : ''}${hours}:${mins < 10 ? '0' : ''}${mins}`
}

export const formatDateTime = (str) => {
  return `${formatDate(str)} ${formatTime(str)}`
}
